import React, { Component, PropTypes } from 'react';
import { get } from 'lodash';
import {
    ADD_CONFIG_ROW,
    CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE,
    DELETE_CONFIG_ROW,
    EDIT_CONFIG_ROW,
    MAKE_INVISIBLE_FILTERS,
    MAKE_VISIBLE_FILTERS,
    SET_BOOLEAN_VALUE_IN_CONFIG,
    SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG,
    SET_TEXT_VALUE_IN_CONFIG,
    UNSET_VALUE_IN_CONFIG
} from '../../../constants/ActionTypes';
import { connect } from 'react-redux';
import ModalConfirmationSettings from '../../modals/ModalConfirmationSettings';
import Store from '../../../store/Store';
import ModalLabelSettings from '../../modals/ModalLabelSettings';

class PagesProduct extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const components = get(this.props.routes, [this.props.routes.length - 1, 'components']);
        const { labels, itemToShow } = components;
        return (
            <div>
                {labels ? (
                    <ModalLabelSettings
                        store={Store}
                        router={this.props.router}
                        route={this.props.route}
                        location={this.props.location.pathname}
                        component={itemToShow}
                    />
                ) : (
                    <ModalConfirmationSettings
                        store={Store}
                        router={this.props.router}
                        route={this.props.route}
                        location={this.props.location.pathname}
                        component={itemToShow}
                    />
                )}
            </div>
        );
    }
}

PagesProduct.propTypes = {
    children: PropTypes.element
};

PagesProduct.contextTypes = {
    store: PropTypes.object
};
const mapStateToProps = state => {
    return {
        open: state.app.modal.confirmationInfo.isOpened,
        currentConfigCopy: state.app.data.configuration.configuration.currentConfigCopy,
        component: state.app.modal.confirmationInfo.component,
        languageCode: state.app.data.configuration.configuration.customContentLanguageCode,
        languageList: state.app.selected.languageList,
        defaultLanguageCode: state.app.selected.defaultCode
    };
};

const mapDispatchToProps = dispatch => ({
    close: () => dispatch(modalConfirmationSettingsActions.hide()),
    makeInvisibleFilters: (key, code) => dispatch({ type: MAKE_INVISIBLE_FILTERS, key: key, code: code }),
    makeVisibleFilters: (key, code) => dispatch({ type: MAKE_VISIBLE_FILTERS, key: key, code: code }),
    setConfigText: (code, value) => {
        dispatch({ type: SET_TEXT_VALUE_IN_CONFIG, code: code, value: value });
    },
    setCustomConfigText: (parent, code, value, side, languageCode) => {
        dispatch({
            type: SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG,
            parent: parent,
            code: code,
            languageCode: languageCode,
            side: side,
            value: value
        });
    },
    addConfigRow: (code, path) => {
        dispatch({ type: ADD_CONFIG_ROW, code, path });
    },
    editConfigRow: (parentCode, editCode, index, value) => {
        dispatch({ type: EDIT_CONFIG_ROW, parentCode: parentCode, editCode: editCode, index: index, value: value });
    },
    deleteConfigRow: (parentCode, index) => {
        dispatch({ type: DELETE_CONFIG_ROW, parentCode: parentCode, index: index });
    },
    setConfigBoolean: (code, value) => {
        dispatch({ type: SET_BOOLEAN_VALUE_IN_CONFIG, code: code, value: value });
    },
    changeCustomContentLanguageCode: code => {
        dispatch({ type: CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE, languageCode: code });
    },
    unsetConfigValue: (code) => {
        dispatch({ type: UNSET_VALUE_IN_CONFIG, code: code });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(PagesProduct);



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesProduct.js